import * as THREE from 'three';
import { InsideType } from '../../constants/enum';

/**
 * Utility class chứa các hàm geometry và calculation dùng chung
 */
export class GeometryUtils {
  /**
   * Lấy kích thước của object3D
   * @param {THREE.Object3D} object3D - Object cần đo
   * @returns {Object|null} - {x, y, z, min, max}
   */

  // static getSize(object3D) {
  //   if (!object3D) return null;

  //   const box = new THREE.Box3();

  //   object3D.traverse(obj => {
  //     if (obj.userData?.type === InsideType.LED_EFFECT) return; // bỏ qua
  //     if (!obj.isMesh || !obj.geometry) return;

  //     if (!obj.geometry.boundingBox) obj.geometry.computeBoundingBox();
  //     const meshBox = obj.geometry.boundingBox
  //       .clone()
  //       .applyMatrix4(obj.matrixWorld);
  //     box.union(meshBox);
  //   });

  //   if (box.isEmpty()) return null;

  //   const size = new THREE.Vector3();
  //   box.getSize(size);

  //   return {
  //     x: size.x,
  //     y: size.y,
  //     z: size.z,
  //     min: box.min.clone(),
  //     max: box.max.clone(),
  //   };
  // }

  static handleShowBackPanel = (moduleGroup, hauNgang) => {
    moduleGroup.traverse(child => {
      if (!child.isMesh || !child.name) return;

      if (hauNgang) {
        if (child.name.includes('HAU-NGANG')) {
          child.visible = true;
        } else if (
          child.name.includes('HAU') &&
          !child.name.includes('NGANG')
        ) {
          child.visible = false;
        }
      } else {
        if (child.name.includes('HAU-NGANG')) {
          child.visible = false;
        } else if (
          child.name.includes('HAU') &&
          !child.name.includes('NGANG')
        ) {
          child.visible = true;
        }
      }
    });
  };

  static getSize(object3D) {
    if (!object3D) return null;

    const box = new THREE.Box3().setFromObject(object3D);

    const size = new THREE.Vector3();
    box.getSize(size);

    const min = box.min.clone();
    const max = box.max.clone();

    return {
      x: size.x,
      y: size.y,
      z: size.z,
      min,
      max,
    };
  }

  static getSizeRotation(object3D, inside3D) {
    if (!inside3D && !object3D) return null;

    const box = new THREE.Box3().setFromObject(inside3D);

    const size = new THREE.Vector3();
    box.getSize(size);

    const min = box.min.clone();
    const max = box.max.clone();

    const orientation = this.getModuleOrientation(object3D);

    let data;

    if (orientation === 'NORMAL' || orientation === 'ROTATED_180') {
      data = {
        x: size.x,
        y: size.y,
        z: size.z,
        min,
        max,
      };
    } else if (orientation === 'ROTATED_90' || orientation === 'ROTATED_270') {
      data = {
        x: size.z,
        y: size.y,
        z: size.x,
        min,
        max,
      };
    }

    return data;
  }

  static findTopLevelParent = object => {
    let current = object;
    while (current?.parent && current?.parent?.type !== 'Scene') {
      current = current.parent;
    }
    return current;
  };

  static moduleWithoutAccessory(model) {
    // Tạo một bản sao của model để không ảnh hưởng đến model gốc
    const clonedModel = model.clone();

    // Thu thập tất cả các object cần xóa trước
    const objectsToRemove = [];

    clonedModel.traverse(child => {
      if (
        child.userData?.name?.includes('ACCESSORY') ||
        child.userData?.name?.includes('COUNTERTOP') ||
        child.userData?.name?.includes('BACKSPLASH') ||
        child.userData?.name?.includes('MAT-DA') ||
        child.userData?.name?.includes('VACH-BEP') ||
        child.userData?.type === InsideType.MESH_TEMPLATE ||
        child.userData?.type === InsideType.DOOR ||
        child.userData?.type === InsideType.ACCESSORY_SINK ||
        child.userData?.type === InsideType.ACCESSORY_COOKER ||
        child.userData?.type === InsideType.ACCESSORY_FAUCET ||
        child.userData?.type === InsideType.ACCESSORY_WASHER ||
        child.userData?.type === InsideType.ACCESSORY_HOOD ||
        child.userData?.type === InsideType.ACCESSORY_FRIDGE ||
        child.userData?.type === InsideType.ACCESSORY_DISH_LOWER ||
        child.userData?.type === InsideType.ACCESSORY_DISH_UPPER ||
        child.userData?.type === InsideType.ACCESSORY_GENERAL ||
        child.userData?.type === InsideType.STOOL_CUSHION ||
        child.userData?.type === InsideType.HPANEL ||
        child.userData?.type === InsideType.VPANEL ||
        child.userData?.type === InsideType.VPANEL2 ||
        child.userData?.type === InsideType.VCURVE ||
        child.userData?.type === InsideType.HANDLE ||
        child.userData?.type === InsideType.LIFT_SUPPORT
      ) {
        objectsToRemove.push(child);
      }
    });

    // Xóa các object sau khi traverse xong
    objectsToRemove.forEach(object => {
      if (object.parent) {
        object.parent.remove(object);
      }
    });

    return clonedModel;
  }

  static moduleOnlyFrame(model) {
    // Tạo một bản sao của model để không ảnh hưởng đến model gốc
    const clonedModel = model.clone();

    // Thu thập tất cả các object cần xóa trước
    const objectsToRemove = [];

    // Kiểm tra xem module có phải là module góc hay không
    const isCornerModule =
      !!model.userData?.moduleData?.moduleType?.includes('corner');

    clonedModel.traverse(child => {
      if (
        child.userData?.name?.includes('ACCESSORY') ||
        child.userData?.name?.includes('COUNTERTOP') ||
        child.userData?.name?.includes('BACKSPLASH') ||
        child.userData?.name?.includes('MAT-DA') ||
        child.userData?.name?.includes('VACH-BEP') ||
        child.userData?.isInside === true ||
        child.userData?.type === InsideType.MESH_TEMPLATE ||
        child.userData?.type === InsideType.DOOR ||
        child.userData?.type === InsideType.ACCESSORY_SINK ||
        child.userData?.type === InsideType.ACCESSORY_COOKER ||
        child.userData?.type === InsideType.ACCESSORY_FAUCET ||
        child.userData?.type === InsideType.ACCESSORY_WASHER ||
        child.userData?.type === InsideType.ACCESSORY_HOOD ||
        child.userData?.type === InsideType.ACCESSORY_FRIDGE ||
        child.userData?.type === InsideType.ACCESSORY_DISH_LOWER ||
        child.userData?.type === InsideType.ACCESSORY_DISH_UPPER ||
        child.userData?.type === InsideType.ACCESSORY_GENERAL ||
        child.userData?.type === InsideType.STOOL_CUSHION ||
        child.userData?.type === InsideType.HANDLE ||
        child.userData?.type === InsideType.HPANEL ||
        child.userData?.type === InsideType.VPANEL ||
        child.userData?.type === InsideType.VPANEL2 ||
        child.userData?.type === InsideType.VCURVE ||
        child.userData?.type === InsideType.DRAWER ||
        child.userData?.type === InsideType.U_DRAWER ||
        child.userData?.type === InsideType.BRACE ||
        child.userData?.type === InsideType.CHAN_ROI_TV ||
        child.userData?.type === InsideType.KHUNG_SAT
      ) {
        //Giữ lại chân tủ nếu là chân tủ và legIndex <= 1 (2 chân góc trái)
        if (
          (child.userData?.type === InsideType.CHAN_ROI_TV ||
            child.userData?.type === InsideType.KHUNG_SAT) &&
          (child.userData?.legIndex <= 1 ||
            child.parent.userData?.legIndex <= 1)
        ) {
          return;
        }

        //Giữ lại MB mẫu cho tủ góc L3
        if (
          isCornerModule &&
          (child.userData?.name?.includes('COUNTERTOP') ||
            child.userData?.name?.includes('MAT-DA'))
        ) {
          return;
        }

        objectsToRemove.push(child);
      }
    });

    // Xóa các object sau khi traverse xong
    objectsToRemove.forEach(object => {
      if (object.parent) {
        object.parent.remove(object);
      }
    });

    return clonedModel;
  }

  static disposeObject3D(object) {
    object.traverse(child => {
      if (child.isMesh) {
        child.geometry?.dispose();

        if (Array.isArray(child.material)) {
          child.material.forEach(m => m.dispose());
        } else {
          child.material?.dispose();
        }
      }
    });

    object.clear();
  }

  /**
   * Xác định orientation của module dựa trên rotation
   * @param {THREE.Group} clonedModule - Module cần kiểm tra
   * @returns {string} - 'NORMAL', 'ROTATED_90', 'ROTATED_180', 'ROTATED_270', 'CUSTOM'
   */
  static getModuleOrientation(group) {
    if (!group) return 'NORMAL';

    const quaternion = new THREE.Quaternion();
    group.getWorldQuaternion(quaternion);

    // Tính góc xoay quanh trục Y (yaw)
    const sinyCosp =
      2 * (quaternion.w * quaternion.y + quaternion.z * quaternion.x);
    const cosyCosp =
      1 - 2 * (quaternion.y * quaternion.y + quaternion.x * quaternion.x);
    const rotationY = Math.atan2(sinyCosp, cosyCosp); // giá trị thực sự quanh Y

    const normalized =
      ((rotationY % (Math.PI * 2)) + Math.PI * 2) % (Math.PI * 2);
    const tolerance = 0.01;

    if (
      Math.abs(normalized) < tolerance ||
      Math.abs(normalized - Math.PI * 2) < tolerance
    )
      return 'NORMAL';
    if (Math.abs(normalized - Math.PI / 2) < tolerance) return 'ROTATED_90';
    if (Math.abs(normalized - Math.PI) < tolerance) return 'ROTATED_180';
    if (Math.abs(normalized - (3 * Math.PI) / 2) < tolerance)
      return 'ROTATED_270';

    return 'CUSTOM';
  }

  // static getModuleOrientation(group) {
  //   if (!group) return "NORMAL";

  //   // Lấy rotation theo world space
  //   const worldQuaternion = new THREE.Quaternion();
  //   group.getWorldQuaternion(worldQuaternion);

  //   // Convert quaternion về Euler angles
  //   const worldEuler = new THREE.Euler();
  //   worldEuler.setFromQuaternion(worldQuaternion, "XYZ");

  //   const rotationY = worldEuler.y;

  //   // Normalize rotation về khoảng [0, 2π]
  //   const normalizedRotation =
  //     ((rotationY % (Math.PI * 2)) + Math.PI * 2) % (Math.PI * 2);

  //   // Kiểm tra các góc chuẩn (với tolerance nhỏ để tránh lỗi floating point)
  //   const tolerance = 0.01;

  //   if (
  //     Math.abs(normalizedRotation) < tolerance ||
  //     Math.abs(normalizedRotation - Math.PI * 2) < tolerance
  //   ) {
  //     return "NORMAL"; // rotation.y = 0, tính theo chiều Z
  //   } else if (Math.abs(normalizedRotation - Math.PI / 2) < tolerance) {
  //     return "ROTATED_90"; // rotation.y = π/2, tính theo chiều X
  //   } else if (Math.abs(normalizedRotation - Math.PI) < tolerance) {
  //     return "ROTATED_180"; // rotation.y = π
  //   } else if (Math.abs(normalizedRotation - (3 * Math.PI) / 2) < tolerance) {
  //     return "ROTATED_270"; // rotation.y = -π/2 hoặc 3π/2, tính theo chiều X
  //   }

  //   return "CUSTOM"; // Góc quay tùy chỉnh
  // }

  /**
   * Tìm mesh trong group theo tên
   * @param {THREE.Object3D} object3D - Object chứa mesh
   * @param {string} name - Tên mesh cần tìm
   * @returns {THREE.Mesh|null} - Mesh tìm được hoặc null
   */
  static getMeshByName(object3D, name) {
    let foundMesh = null;

    object3D?.traverse(child => {
      if ((child.isMesh || child.isGroup) && child.name === name) {
        foundMesh = child;
      }
    });

    return foundMesh;
  }

  static getMeshByNameOrIncludes(object3D, name) {
    const exactMesh = this.getMeshByName(object3D, name);

    if (exactMesh) {
      return exactMesh;
    }

    let foundMesh = null;

    object3D?.traverse(child => {
      if (
        !foundMesh &&
        (child.isMesh || child.isGroup) &&
        child.name?.includes(name)
      ) {
        foundMesh = child;
      }
    });

    return foundMesh;
  }

  /**
   * Tìm mesh trong group theo UUID
   * @param {THREE.Object3D} group - Group chứa các mesh
   * @param {string} uuid - UUID của mesh cần tìm
   * @returns {THREE.Object3D|null} - Mesh object hoặc null nếu không tìm thấy
   */
  static findMeshByUuid(group, uuid) {
    if (!group || !uuid) return null;

    let foundMesh = null;

    const traverse = object => {
      if (object.uuid === uuid) {
        foundMesh = object;
        return;
      }

      if (object.children && object.children.length > 0) {
        for (const child of object.children) {
          traverse(child);
          if (foundMesh) break; // Dừng khi đã tìm thấy
        }
      }
    };

    traverse(group);
    return foundMesh;
  }

  /**
   * Tính khoảng cách bounding box giữa 2 mesh
   * @param {THREE.Object3D} mesh1 - Mesh thứ nhất
   * @param {THREE.Object3D} mesh2 - Mesh thứ hai
   * @returns {number} - Khoảng cách
   */
  static bboxDistance(mesh1, mesh2) {
    const box1 = new THREE.Box3().setFromObject(mesh1);
    const box2 = new THREE.Box3().setFromObject(mesh2);

    if (box1.intersectsBox(box2)) {
      return 0; // chạm nhau
    }

    // khoảng cách ngắn nhất giữa 2 bounding box
    const v1 = new THREE.Vector3();
    const v2 = new THREE.Vector3();
    box1.clampPoint(box2.getCenter(v1), v1);
    box2.clampPoint(box1.getCenter(v2), v2);

    return v1.distanceTo(v2);
  }

  /**
   * Lấy các UUID trong mesh (bao gồm cả children)
   * @param {THREE.Object3D} mesh - Mesh cần lấy UUID
   * @returns {string[]} - Mảng các UUID
   */
  static getUuidInMesh(mesh) {
    const ids = [];
    mesh.traverse(x => {
      ids.push(x.uuid);
    });
    return ids;
  }

  /**
   * Reset group position về current position
   * @param {THREE.Group} group - Group cần reset
   */
  static resetGroupPositionToCurrentPosition(group) {
    const boundingBox = new THREE.Box3().setFromObject(group);

    const min = boundingBox.min;
    const max = boundingBox.max;

    const offset = new THREE.Vector3(
      min.x - group.position.x,
      min.y - group.position.y,
      max.z - group.position.z
    );

    group.position.add(offset);

    group.children.forEach(child => {
      child.position.sub(offset);
    });
  }

  /**
   * Lấy local transform của obj tương đối so với parent
   * @param {THREE.Object3D} obj - Object cần lấy transform
   * @returns {Object} - {p: [x,y,z], r: [x,y,z], s: [x,y,z]}
   */
  static getLocalTRS(obj) {
    return {
      p: [obj.position.x, obj.position.y, obj.position.z],
      r: [obj.rotation.x, obj.rotation.y, obj.rotation.z],
      s: [obj.scale.x, obj.scale.y, obj.scale.z],
    };
  }

  /**
   * Apply local transform cho object
   * @param {THREE.Object3D} obj - Object cần apply transform
   * @param {Object} trs - Transform data {p, r, s}
   */
  static applyLocalTRS(obj, trs) {
    if (!trs) return;

    const [px, py, pz] = trs.p || [0, 0, 0];
    const [rx, ry, rz] = trs.r || [0, 0, 0];
    const [sx, sy, sz] = trs.s || [1, 1, 1];

    obj.position.set(px, py, pz);
    obj.rotation.set(rx, ry, rz);
    obj.scale.set(sx, sy, sz);
    obj.updateMatrixWorld(true);
  }

  /**
   * Lấy các tâm của các mặt của hình hộp (box) dựa trên center và size
   * @param {THREE.Vector3} center - Tâm của box
   * @param {THREE.Vector3} size - Kích thước của box
   * @returns {Object} - Object chứa các face center
   */
  static getFaceCenters(center, size) {
    const hx = size.x / 2;
    const hy = size.y / 2;
    const hz = size.z / 2;

    const { x: cx, y: cy, z: cz } = center;

    return {
      X1: new THREE.Vector3(cx + hx, cy, cz),
      X2: new THREE.Vector3(cx - hx, cy, cz),
      Y1: new THREE.Vector3(cx, cy + hy, cz),
      Y2: new THREE.Vector3(cx, cy - hy, cz),
      Z1: new THREE.Vector3(cx, cy, cz + hz),
      Z2: new THREE.Vector3(cx, cy, cz - hz),
    };
  }

  /**
   * Kiểm tra xem UUID có tồn tại trong userData không
   * @param {Object} data - Object userData cần kiểm tra
   * @param {string} targetUuid - UUID cần tìm
   * @returns {boolean} - true nếu tồn tại
   */
  static checkUuidExists(data, targetUuid) {
    const uuidFields = [
      'leftEdgeUuid',
      'rightEdgeUuid',
      'topEdgeUuid',
      'bottomEdgeUuid',
    ];

    return uuidFields.some(field => data[field] === targetUuid);
  }

  /**
   * Tính khoảng cách từ mesh đến edge
   * @param {Object} params - {mesh, edge, orientation}
   * @returns {Object} - {distance, endpoints, module}
   */
  static calculateDistanceToEdge({ mesh, edge, orientation }) {
    const boxMesh = new THREE.Box3().setFromObject(mesh);
    const boxEdge = new THREE.Box3().setFromObject(edge);

    if (boxMesh.intersectsBox(boxEdge))
      return { distance: 0, endpoints: [], module: edge };

    // const edgeCenter = boxEdge.getCenter(new THREE.Vector3());
    // const edgeSize = boxEdge.getSize(new THREE.Vector3());
    const meshCenter = boxMesh.getCenter(new THREE.Vector3());
    const meshSize = boxMesh.getSize(new THREE.Vector3());

    const dx = Math.max(
      0,
      Math.max(boxMesh.min.x - boxEdge.max.x, boxEdge.min.x - boxMesh.max.x)
    );
    const dy = Math.max(
      0,
      Math.max(boxMesh.min.y - boxEdge.max.y, boxEdge.min.y - boxMesh.max.y)
    );
    const dz = Math.max(
      0,
      Math.max(boxMesh.min.z - boxEdge.max.z, boxEdge.min.z - boxMesh.max.z)
    );

    const distance = Math.sqrt(dx * dx + dy * dy + dz * dz);

    const faceData = {
      z1: { normal: new THREE.Vector3(0, 0, 1), offset: meshSize.z / 2 },
      z2: { normal: new THREE.Vector3(0, 0, -1), offset: meshSize.z / 2 },
      y1: { normal: new THREE.Vector3(0, 1, 0), offset: meshSize.y / 2 },
      y2: { normal: new THREE.Vector3(0, -1, 0), offset: meshSize.y / 2 },
    };

    const face = faceData[orientation];
    if (!face) return { distance: 0, endpoints: [], module: edge };

    const planePoint = meshCenter
      .clone()
      .add(face.normal.clone().multiplyScalar(face.offset));
    const targetPoint = planePoint
      .clone()
      .add(face.normal.clone().multiplyScalar(distance));

    return {
      distance,
      endpoints: [planePoint, targetPoint],
      module: edge,
    };
  }
}
